import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import AppSidebar from "./sidebar.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoon, faSun, faSearch } from "@fortawesome/free-solid-svg-icons";

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [dark, setDark] = useState(() => localStorage.getItem("theme") === "dark");
  const [globalSearch, setGlobalSearch] = useState("");
  const navigate = useNavigate();

  const handleGlobalSearch = (e) => {
    e.preventDefault();
    const q = globalSearch.trim();
    if (!q) return;
    localStorage.setItem("globalSearch", q);
    if (/^\d{7,}$/.test(q)) {
      navigate("/user-management/match-seekers/list");
    } else if (/profile|bg/i.test(q)) {
      navigate("/user-management/bride-groom-profile/list");
    } else {
      navigate("/user-management/match-seekers/list");
    }
    setGlobalSearch("");
  };

  useEffect(() => {
    if (dark) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  }, [dark]);

  return (
    <div className="min-h-screen bg-[#F1F5F9] flex">
      <AppSidebar
        isOpen={sidebarOpen}
        toggleSidebar={() => setSidebarOpen((v) => !v)}
        dark={dark}
        toggleDark={() => setDark((v) => !v)}
      />
      <main
        className="flex-1 min-h-screen transition-all duration-300"
        style={{ marginLeft: sidebarOpen ? "240px" : "64px" }}
      >
        {/* Top nav bar */}
        <div
          className="fixed top-0 right-0 z-20 flex items-center justify-between px-6 py-3 bg-white/80 backdrop-blur border-b border-gray-100 shadow-sm transition-all duration-300"
          style={{ left: sidebarOpen ? "240px" : "64px" }}
        >
          {/* Global Search */}
          <form onSubmit={handleGlobalSearch} className="flex items-center gap-2">
            <div className="relative">
              <FontAwesomeIcon icon={faSearch} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-xs pointer-events-none" />
              <input
                type="text"
                value={globalSearch}
                onChange={(e) => setGlobalSearch(e.target.value)}
                placeholder="Search users, profiles..."
                className="pl-8 pr-4 py-1.5 text-sm rounded-full bg-slate-100 border border-slate-200 text-slate-700 placeholder-slate-400 w-48 focus:w-72 transition-all focus:outline-none focus:ring-2 focus:ring-indigo-300 focus:bg-white"
              />
            </div>
          </form>

          <button
            onClick={() => setDark((v) => !v)}
            title={dark ? "Switch to light mode" : "Switch to dark mode"}
            className="w-9 h-9 flex items-center justify-center rounded-lg text-slate-500 hover:text-indigo-600 hover:bg-indigo-50 transition"
          >
            <FontAwesomeIcon icon={dark ? faSun : faMoon} className="text-base" />
          </button>
        </div>

        <div className="p-6 pt-[72px]">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout;
